const UserCreateAccount = {
  'pages_user_UserCreateAccount.download_filename': '담당자',
  'pages_user_UserCreateAccount.download_filename_company': '회사',
  'pages_user_UserCreateAccount.1': '신규 계정 생성',
  'pages_user_UserCreateAccount.2': '담당자 선택',
  'pages_user_UserCreateAccount.3': '담당자 정보 입력',
  'pages_user_UserCreateAccount.4': '회사 선택',
  'pages_user_UserCreateAccount.5': '계정 선택',
  'pages_user_UserCreateAccount.path.1': '사용자 목록',
  'pages_user_UserCreateAccount.path.2': '신규 계정 생성',
  'pages_user_UserCreateAccount.create_user': '계정을 생성하였습니다.',
  'pages_user_UserCreateAccount.nameLengthOver': '이름 최대 길이는 150자 입니다.',
  'pages_user_UserCreateAccount.telNoLengthOver': '연락처의 최대 길이는 45자 입니다.',
  'pages_user_UserCreateAccount.emailLengthOver': '이메일의 최대 길이는 100자 입니다.',
  'pages_user_UserCreateAccount.existsEmail': '이미 등록된 이메일 입니다.',
  'pages_user_UserCreateAccount.existsUser': '이미 등록된 사용자 입니다.',
  'pages_user_UserCreateAccount.error': '생성중 오류가 발생하였습니다.',
  'pages_user_UserCreateAccount.chooseUser': '통합 계정 선택',
  'pages_user_UserCreateAccount.userGroups': '소속 그룹',
  'pages_user_UserCreateAccount.settingAuth': '권한 설정',
  'pages_user_UserCreateAccount.shouldSettingAuth': '권한을 선택하십시오.',
  'pages_user_UserCreateAccount.shouldSettingCompany': "회사를 선택하십시오.",
  'pages_user_UserCreateAccount.editAuth': "권한 수정",
  'pages_user_UserCreateAccount.editCustomer': "회사 수정",
  'pages_user_UserCreateAccount.changeCustomer': "회사를 수정 하시겠습니까?",
  'pages_user_UserCreateAccount.haschangedCustomer': "회사가 수정 되었습니다."
  
}

export default UserCreateAccount



// WEBPACK FOOTER //
// ./src/lang/user/UserCreateAccount.kr.js